import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {
  AuthService,
  NotificationService,
  StorageService,
} from '@chefami-monorepo/data-access';
import { SiteCookies, SiteStorage } from '@chefami-monorepo/types';
import { SiteText } from '@chefami-monorepo/utils/constants';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const storage = inject(StorageService);
  const notification = inject(NotificationService);

  if (auth.isLoggedIn()) {
    return true;
  }

  storage.setItem(SiteStorage.RETURN_URL, state.url, true);

  const hasAccessToken = !!storage.getCookie(SiteCookies.ACCESS_TOKEN);
  const hasRefreshToken = !!storage.getCookie(SiteCookies.REFRESH_TOKEN);

  if (hasAccessToken || hasRefreshToken) {
    storage.deleteTokens();
  }

  void notification.error(SiteText.SESSION_ERROR);
  return router.parseUrl('/login');
};
